import { calcDuration } from 'cross-state';
import z from 'zod';

export const Duration = z
    .union([
        z.number(),
        z.string(),
        z.object({
            nanoseconds: z.number().optional(),
            microseconds: z.number().optional(),
            milliseconds: z.number().optional(),
            seconds: z.number().optional(),
            minutes: z.number().optional(),
            hours: z.number().optional(),
            days: z.number().optional(),
            months: z.number().optional(),
            years: z.number().optional(),
        }),
    ])
    .transform((value, context) => {
        try {
            return calcDuration(value);
        } catch {
            context.addIssue(`Invalid duration value: ${value}`);
            return z.NEVER;
        }
    });
